import React from 'react'

function ContactPageBreadcrumb() {
    return (
        <div className="about-page-breadcrumb">
            <div className="container">
                <h1 className="about-page-breadcrumb__title">Contact Us</h1>
            </div>
        </div>
    )
}

export default ContactPageBreadcrumb
